// Resolve a deliverable's mimetype from metadata, top-level field, or filename
// extension, in that order — used for both icon resolution and file-view opening
// so the two never disagree on what kind of file this is.
export const resolveDeliverableMimetype = (item) => {
  let resolvedMime = item.metadata?.mimetype || item.mimetype || "";
  if (!resolvedMime && item.name) {
    const lowerName = item.name.toLowerCase();
    if (lowerName.endsWith(".docx") || lowerName.endsWith(".doc")) {
      resolvedMime =
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    } else if (lowerName.endsWith(".pdf")) {
      resolvedMime = "application/pdf";
    } else if (lowerName.endsWith(".xlsx") || lowerName.endsWith(".xls")) {
      resolvedMime =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    } else if (lowerName.endsWith(".jpg") || lowerName.endsWith(".jpeg")) {
      resolvedMime = "image/jpeg";
    } else if (lowerName.endsWith(".png")) {
      resolvedMime = "image/png";
    }
  }
  return resolvedMime;
};
